import { useQuery } from '@tanstack/react-query'
import { sportsApi } from '../api/client'
import type { Sport } from '../types'

export function useLiveScores(sport?: Sport) {
  return useQuery({
    queryKey: ['liveScores', sport],
    queryFn: () => sportsApi.getLiveScores(sport),
    refetchInterval: 30000, // Refresh every 30 seconds
  })
}

export function useGamesByDate(sport: Sport, date: string) {
  return useQuery({
    queryKey: ['games', sport, date],
    queryFn: () => sportsApi.getGamesByDate(sport, date),
    enabled: !!sport && !!date,
  })
}

export function useUpcomingGames(sport: Sport, limit = 10) {
  return useQuery({
    queryKey: ['upcomingGames', sport, limit],
    queryFn: () => sportsApi.getUpcomingGames(sport, limit),
    enabled: !!sport,
  })
}
